export default "__VITE_ASSET__BvsmLUTI__"